export enum LinksRouteName {
    Index = 'system.links.index',
    Create = 'system.links.create',
    Edit = 'system.links.edit',
}

export default {
    path: 'links',
    name: LinksRouteName.Index,
    component: () => import('@/views/system/link/Index.vue'),
    meta: {
        auth: true,
        label: 'Links',
        icon: 'fal fa-globe fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-links',
    },
    children: [
        {
            path: 'create',
            name: LinksRouteName.Create,
            component: () => import('@/views/system/link/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Link',
                group: 'main',
                permission: 'manage-links',
            },
        },
        {
            path: ':linkId/edit',
            name: LinksRouteName.Edit,
            component: () => import('@/views/system/link/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Link',
                group: 'main',
                permission: 'manage-links',
            },
        },
    ],
}
